import { useState, useContext, useEffect } from "react"
import { Camelcase, CamelCaseWithSpaces, formatDateToUsaMMDDYYYY, GetAllSchoolsByLocation, getTypeWatchDelay, HideLoder, RemoveAllCookies, ShowLoder, transformNameOfCol, typewatch } from "../../JS/Common";
import { ApiGetCall, ApiGetHeaders, ApiPostCall } from "../../JS/Connector";
import AlertsComp from "../../Components/AlertsComp";
import { CheckValidation } from "../../Components/Validations";
import { UserContext } from "../../App";
import { MDBSwitch } from "mdb-react-ui-kit";
import Pagination from "react-js-pagination";
import CustomizationPopup from "../../Components/CustomizationPopup";
import PageHead from "../../Components/PageHead";
import Popup from "../../Components/Popup";
import AlertPopup from "../../Components/AlertPopup";
import Tab from "../../Components/Tab";
import useConfig from "../../Hooks/useConfig";

export function DomainIndex() {
    const { organization, organizations, adminCallNode } = useConfig();
    const { UserData } = useContext(UserContext);
    const [isDomainPopup, setisDomainPopup] = useState(false);
    const [deleteDomainPopup, setDeleteDomainPopup] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const [DomainData, setDomainData] = useState([]);
    const [allData, setAllData] = useState({
        DomainName: "",
        DomainId: 0,
        UpdateFlag: 1,
        SortbyFlag: 'asc',
        SortKey: null
    });
    const [loading, setLoading] = useState(false);
    const [Searchstring, setSearchstring] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = DomainData.length > 0;
    const [DeactiveToActivePopup, setDeactiveToActivePopup] = useState(false);
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [Schools, setSchools] = useState([]);
    const [DomainTabs, setDomainTabs] = useState({
        currentAllowed: "active",
        schoolAllowed: "",
        blackListed: ""
    })
    const [schoolIdParam, setSchoolId] = useState(0);
    const [blacklistDomainPopup, setBlacklistDomainPopup] = useState({
        show: false,
        flag: null,
    });
    const domainsFlag = DomainTabs.currentAllowed == "active" ? 1 : DomainTabs.schoolAllowed == "active" ? 2 : 3

    useEffect(() => {
        const sortFlagOnPageChange = DomainTabs.schoolAllowed != "active" ? allData.SortKey ? allData.SortKey : "Name" : allData.SortKey ? allData.SortKey : "created_at";
        GetAllDomains(
            domainsFlag, // Domain Tab Flag
            schoolIdParam ? schoolIdParam : null, // School Id Parameter
            Searchstring ? Searchstring : null, // Serach String
            sortFlagOnPageChange, // Table Sort Key
            allData.SortbyFlag, // Table Sort Flag
            false // Ctrl Toogle Sort
        );
    }, [currentPage, LimitForPagination]);

    useEffect(() => {
        ApiGetHeaders(DomainTabs.schoolAllowed != "active" ? 34 : 46, setColumnNames);
        GetAllSchoolsByLocation({ setAllSchool: setSchools });
    }, [DomainTabs])

    async function GetAllDomains(tabFlag, SchoolId, searchstring, sortKey, Sflag, toogleSort) {
        if (searchstring == "" || searchstring == null) {
            searchstring = null;
        } else {
            searchstring = searchstring.trim().replace(/\s+/g, " ");
        }
        if (toogleSort) {
            if (Sflag == 'asc') {
                Sflag = 'desc'
            } else {
                Sflag = 'asc'
            }
        }
        setSchoolId(SchoolId ? SchoolId : 0);
        if (SchoolId == 0) SchoolId = null;
        setAllData({ ...allData, SortbyFlag: Sflag, SortKey: sortKey });
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/domains/all?flag=${tabFlag}&schoolId=${SchoolId}&search=${searchstring}&sortBy=${sortKey}&sortByOrder=${Sflag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    setLoading(false);
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setpageRangeCount(responseRs.total)
                    if (responseRs.length != 0) {
                        setDomainData(responseRs.data);
                    }
                    else {
                        setDomainData([]);
                    }
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }
    async function AddUpdateDomain() {
        var isFormValid = CheckValidation({ formID: 'DomainPopup' });
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            uuid: allData.DomainId == '' ? 0 : allData.DomainId,
            name: allData.DomainName,
            status: DomainTabs.blackListed == "active" ? 3 : 1
        });
        await ApiPostCall(`${adminCallNode}/domains/save`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={`Domain ${allData.UpdateFlag == 1 ? 'Added' : 'Updated'} Successfully.`} />);
                    setisDomainPopup(false);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        GetAllDomains(domainsFlag, null, null, null, 'asc', false);
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
            }
        });
    }
    async function ActiveDeactive(id, name, flag) {
        setLoading(true);
        var loginemailid = UserData.emailid;
        var vsplit = loginemailid.split('@');
        var domainname = vsplit[1];
        var raw = JSON.stringify({
            uuid: id,
            flag: flag,
            name: flag == 4 || flag == 5 ? null : name,
            status: DomainTabs.blackListed == "active" ? 3 : 1
        });
        await ApiPostCall(`${adminCallNode}/domains/save`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (flag == 1) {
                    setDeactiveToActivePopup(false)
                }
                if (responseRs.response == "success") {
                    const msgMap = { 1: "Activated", 2: "Deactivated", 3: "Deleted", 4: "Blacklisted", 5: "Allowed" };
                    setAlerts(<AlertsComp show={true} variant="success" msg={`Domain ${msgMap[flag]} Successfully.`} />);

                    GetAllDomains(domainsFlag, null, null, null, 'asc', false);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                    if (domainname == name) {
                        RemoveAllCookies();
                    }
                    setDeleteDomainPopup(false);
                    setBlacklistDomainPopup(prev => ({ ...prev, show: false, flag: null }));
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                    setDeleteDomainPopup(false);
                    setBlacklistDomainPopup(prev => ({ ...prev, show: false, flag: null }));
                }
            }
        });
    }
    async function EditDomain(id) {
        setisDomainPopup(true);
        setLoading(true);
        await ApiGetCall(`${adminCallNode}/domains/by-id?uuid=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setAllData({ ...allData, UpdateFlag: 2, DomainName: responseRs.name, DomainId: responseRs.id });
            }
        });
    }
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            [DomainTabs.schoolAllowed != "active" ? 'Name' : 'Domain']: item?.domain || "-",
            "School_Name": item?.name || "-",
            "created_at": formatDateToUsaMMDDYYYY(item.created_at) || "-",
        };
        return contentMap[columnName] || null;
    }

    function handleSearchChange(e) {
        setCurrentPage(1);
        GetAllDomains(domainsFlag, null, e.target.value?.trim(), null, allData.SortbyFlag, false);
        setSearchstring(e.target.value)
    }
    const modalBody = (
        <>
            {allData.UpdateFlag == 1 ?
                <div className="col-12 FormLabel">
                    {DomainTabs.blackListed == "active" ?
                        <> You can blacklist {organization} Domain names here in order to restrict Members with those domain emails from signing up or logging in.
                            Use comma (,) to separate multiple domain names and add them all in one click. Eg. outlook.com, gmail.com
                        </>
                        : <> You can approve {organization} Domain names here in order to let {organization} Members use their domain emails associated with Google or Microsoft to sign-up/login. Use comma(,) to separate multiple domain names and add them all in one click.
                            Eg. outlook.com, gmail.com
                        </>
                    }
                </div> :
                <div className="col-12 FormLabel">
                    {DomainTabs.blackListed == "active" ?
                        <> You can blacklist {organization} Domain names here in order to prevent {organization} Members from using their domain emails associated with Google or Microsoft to sign-up/login.
                        </> : <> You can approve {organization} Domain names here in order to let {organization} Members use their domain emails associated with Google or Microsoft to sign-up/login.
                        </>
                    }
                </div>
            }
            <div id="DomainPopup" className="parent">
                <div className='col-12 pt-3'>
                    {allData.UpdateFlag == 1 ?
                        <>
                            <textarea className="form-control" required value={allData.DomainName}
                                onChange={(e) => setAllData({ ...allData, DomainName: e.target.value })} />
                            <div className='FormLabel'>Domain Name(s)<label className='redText'>*</label></div>
                        </>
                        :
                        <>
                            <input className="form-control" required value={allData.DomainName} onChange={(e) => setAllData({ ...allData, DomainName: e.target.value })} />
                            <div className='FormLabel'>Domain Name</div>
                        </>
                    }
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
            </div>
        </>
    )

    const handleTabClick = (tabType) => {
        setCurrentPage(1);
        setSearchstring("");
        if (tabType == "currentAllowed") {
            setDomainTabs({ ...DomainTabs, currentAllowed: "active", schoolAllowed: "", blackListed: "" });
            GetAllDomains(1, null, null, "Name", 'asc', false);
        } else if (tabType == "schoolAllowed") {
            setDomainTabs({ ...DomainTabs, currentAllowed: "", schoolAllowed: "active", blackListed: "" });
            GetAllDomains(2, null, null, "created_at", 'desc', false);
        } else if (tabType == "blackListed") {
            setDomainTabs({ ...DomainTabs, currentAllowed: "", schoolAllowed: "", blackListed: "active" });
            GetAllDomains(3, null, null, "Name", 'asc', false);
        }
    }

    const handleSortClick = (sortKey) => {
        GetAllDomains(domainsFlag, schoolIdParam, Searchstring ? Searchstring : null, sortKey, allData.SortbyFlag, true);
    }

    const handleFilterBySchool = (SchoolId) => {
        setCurrentPage(1);
        GetAllDomains(domainsFlag, SchoolId, null, null, allData.SortbyFlag, false);
    }

    const ExportSchoolDomainData = async () => {
        await ApiGetCall(`${adminCallNode}/domains/export`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                DownloadCsv(responseRs);
            }
        });
    }

    const DownloadCsv = (SchoolCsvData) => {
        const csvContent = [];
        const domainMap = [];
        SchoolCsvData?.forEach((item) => {
            const rowData = {
                [organization]: item.name,
                'Domain': item.domain,
                'Created At': formatDateToUsaMMDDYYYY(item.created_at)
            }
            domainMap.push(rowData);
        })
        const headers = [`${organization}`, 'Domain', 'Created At'];
        csvContent.push(headers);
        domainMap.forEach((rowData) => {
            const values = Object.values(rowData).map(value => {
                const strVal = value != null ? value.toString() : '';
                if (strVal.includes(',') || strVal.includes('"') || strVal.includes('\n')) {
                    const escaped = strVal.replace(/"/g, '""');
                    return `"${escaped}"`;
                }
                return strVal;
            });
            csvContent.push(values);
        })
        csvContent.push([]);
        const csvString = csvContent.map((row) => row.join(',')).join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${organization}Domains.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return (
        <>
            {Alerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Domains"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />

            <div className="GridBox mt-2 p-3">
                <div className="greyBox p-3">
                    <section>
                        <div className='row align-items-center mb-2'>
                            <div className="col-md-6 pe-0">
                                <ul className="nav nav-tabs">
                                    <Tab isActive={DomainTabs.currentAllowed == 'active'}
                                        label="Current Allowed" onClick={() => handleTabClick('currentAllowed')} />
                                    <Tab isActive={DomainTabs.schoolAllowed == 'active'}
                                        label={`${organization} Allowed`} onClick={() => handleTabClick('schoolAllowed')} />
                                    <Tab isActive={DomainTabs.blackListed == 'active'}
                                        label={`Blacklisted`} onClick={() => handleTabClick('blackListed')} />
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <div className="row">

                                    {DomainTabs.currentAllowed == "active" &&
                                        <div className="offset-md-7 col-md-5 ps-0 text-end">
                                            <label
                                                style={{ marginRight: 0 }}
                                                className='BorderBtn text-end'
                                                onClick={(e) => {
                                                    setisDomainPopup(true);
                                                    setAllData({ ...allData, UpdateFlag: 1, DomainId: "", DomainName: "" })
                                                }}
                                                title="Add Domain"
                                            >
                                                Add Domain
                                                <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                                            </label>
                                        </div>
                                    }
                                    {DomainTabs.schoolAllowed == "active" &&
                                        <>
                                            <div className="col-md-8 text-end">
                                                <label title={`Export ${organization} Domain CSV`} className="BorderBtn" onClick={() => { ExportSchoolDomainData() }}>
                                                    Export {organization} Domain CSV
                                                    <img src="/images/ExportInventory.svg" className="img-fluid ps-2" />
                                                </label>
                                            </div>
                                            <div className="col-md-4 px-0">
                                                <select onChange={(e) => handleFilterBySchool(e.target.value)}>
                                                    <option value="0">
                                                        Filter by {organization}
                                                    </option>
                                                    {Schools.map((item, i) => (
                                                        <option value={item.id} key={i}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </>
                                    }
                                    {DomainTabs.blackListed == "active" && (
                                        <>
                                            <div className="offset-md-5 col-md-7 ps-0 text-end">
                                                <label
                                                    style={{ marginRight: 0 }}
                                                    className='BorderBtn text-end'
                                                    onClick={(e) => {
                                                        setisDomainPopup(true);
                                                        setAllData({ ...allData, UpdateFlag: 1, DomainId: "", DomainName: "" })
                                                    }}
                                                    title="Add Blacklisted Domain"
                                                >
                                                    Add Blacklisted Domain
                                                    <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                                                </label>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>

                        <table className="table data-table mt-2">
                            <thead className='GridHeader'>
                                <tr>
                                    {columnNames?.map((item, index) => {
                                        const columnName = item.replace(/_/g, ' ');
                                        const transformedName = item == 'School_Name' ? `${organization} Name` : transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return (
                                            DomainTabs.currentAllowed == "active" && item == "created_at" ?
                                                <th key={item} scope="col" className='fw-600'>
                                                    {Camelcase(transformedName)}
                                                </th>
                                                :
                                                <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                    {Camelcase(transformedName)}
                                                    <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                    {DomainTabs.blackListed != "active" && columnNames.length - 1 == index &&
                                                        <img
                                                            src="/images/EditHeaderIcon.svg"
                                                            className="img-fluid ps-2 pe-5"
                                                            title='Customize Headers'
                                                            style={{ height: '25px' }}
                                                            onClick={(e) => setCustomizationModal(true)}
                                                        />
                                                    }
                                                </th>
                                        );
                                    })}
                                    {DomainTabs.schoolAllowed != "active" &&
                                        <>
                                            {DomainTabs.currentAllowed && <th scope="col" className='cursor-pointer fw-600 text-center'>Active</th>}
                                            <th scope="col" className='cursor-pointer fw-600 text-center'>Action <img src="/images/EditHeaderIcon.svg" className="img-fluid ps-2 pe-5" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} /></th>
                                        </>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {DomainData.length != 0 ?
                                    DomainData.map((item, i) => {
                                        return <tr key={i} className={`OddEvenClass tableBorderHide`}>
                                            {columnNames?.map(header => (
                                                <td className="py-12" key={header}>
                                                    {renderContentForColumn(header, item)}
                                                </td>
                                            ))}
                                            {DomainTabs.currentAllowed == "active" &&
                                                <>
                                                    <td scope="col" className='text-center py-12'>
                                                        {item.status == 1 ?
                                                            <MDBSwitch className="BgPink cursor-pointer" checked={item?.isChecked || true} onChange={(e) => { ActiveDeactive(item.id, item.name, 2) }} domainid={item.id} />
                                                            :
                                                            <MDBSwitch className="BgPink cursor-pointer" checked={item?.isChecked || false} onChange={(e) => { setAllData({ ...allData, DomainName: item.name, DomainId: item.id }); setDeactiveToActivePopup(true) }} domainid={item.id} />
                                                        }
                                                    </td>

                                                </>
                                            }
                                            <td scope="col" className='text-center py-12'>
                                                {DomainTabs.schoolAllowed != "active" && (
                                                    <img src='/images/EditIconNew.svg' title='Edit Domain' className='img-fluid pe-2 cursor-pointer' onClick={(e) => EditDomain(item.id)} domainid={item.id} />
                                                )}
                                                {DomainTabs.currentAllowed == "active" && (
                                                    <img src="/images/banDomain.svg" title="Blacklist Domain" className="img-fluid pe-2 cursor-pointer"
                                                        onClick={() => {
                                                            setAllData({ ...allData, DomainName: item.domain, DomainId: item.id });
                                                            setBlacklistDomainPopup(prev => ({ ...prev, show: true, flag: 4 }));
                                                        }} />
                                                )}
                                                {DomainTabs.blackListed == "active" && (
                                                    <>
                                                        <img src="/images/setupapprove.svg" title="Allow Domain"
                                                            className="img-fluid pe-2 cursor-pointer" height={'22px'} width={'22px'}
                                                            onClick={() => {
                                                                setAllData({ ...allData, DomainName: item.domain, DomainId: item.id });
                                                                setBlacklistDomainPopup(prev => ({ ...prev, show: true, flag: 5 }));
                                                            }} />
                                                        <img src='/images/DeleteIcon.svg' title='Delete Domain' className='img-fluid pe-2 cursor-pointer' onClick={(e) => { setAllData({ ...allData, DomainName: item.domain, DomainId: item.id }); setDeleteDomainPopup(true); }} domainid={item.id} />
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    })
                                    :
                                    <tr className="text-center">
                                        <td colSpan={4}>No Record Found</td>
                                    </tr>
                                }
                            </tbody>

                        </table>
                    </section>
                </div>
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true}
                    />
                )}
            </div>

            <Popup isshow={isDomainPopup} size={"md"} title={allData.UpdateFlag == 1 ? `Add ${DomainTabs.blackListed == "active" ? 'Blacklisted' : ''} Domain(s)` : `Edit ${DomainTabs.blackListed == "active" ? 'Blacklisted' : ''} Domain`}
                closePopup={(e) => setisDomainPopup(false)}
                modalBody={modalBody} handleSave={AddUpdateDomain} visibleSaveBtn={true} btnText={allData.UpdateFlag == 1 ? 'Save' : 'Update'} />

            <AlertPopup isshow={DeactiveToActivePopup} img={'/images/greenInfo.svg'}
                headingtext={`Are you sure you want to activate this domain? Any ${organizations} linked to this domain registered on the same day will also be activated.`} text={''}
                cancelcall={(e) => { setDeactiveToActivePopup(false) }}
                canceltext={"No"} successtext={"Continue"} successcall={(e) => { ActiveDeactive(allData.DomainId, allData.DomainName, 1) }} btntype={'SaveBtn'} />

            <AlertPopup isshow={deleteDomainPopup} img={'/images/greenInfo.svg'}
                headingtext={`Are you sure you want to delete this Blacklisted Domain? Users with this domain will be able to login after deletion.`} text={''}
                cancelcall={(e) => { setDeleteDomainPopup(false) }}
                canceltext={"No"} successtext={"Continue"} successcall={(e) => { ActiveDeactive(allData.DomainId, allData.DomainName, 3) }} btntype={'SaveBtn'} />

            <AlertPopup isshow={blacklistDomainPopup.show} img={'/images/greenInfo.svg'}
                headingtext={`Are you sure you want to ${blacklistDomainPopup.flag == 4 ? 'Blacklist' : 'Allow'} this Domain? Users with this domain will ${blacklistDomainPopup.flag == 4 ? 'not' : ''} be able to login after ${blacklistDomainPopup.flag == 4 ? 'blacklisted' : 'allowing'}.`}
                cancelcall={(e) => { setBlacklistDomainPopup(prev => ({ ...prev, show: false, flag: null })) }}
                canceltext={"No"} successtext={"Continue"} successcall={(e) => { ActiveDeactive(allData.DomainId, null, blacklistDomainPopup.flag) }} btntype={'SaveBtn'} />

            {CustomizationModal == true && (
                <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={DomainTabs.currentAllowed == "active" ? 'Domains' : DomainTabs.schoolAllowed == "active" ? `${organization} Domains` : `Blacklisted Domains`} GetCall={(e) => { ApiGetHeaders(DomainTabs.schoolAllowed != "active" ? 34 : 46, setColumnNames) }} />
            )}
        </>
    )
}
